import { BulletList } from '@tiptap/extension-list'

export type { BulletListOptions } from '@tiptap/extension-list'
export { BulletList } from '@tiptap/extension-list'

export default BulletList
